import _get from 'lodash/get'

import type { FlowValues } from '@flows/core/types/stepTypes'
import type { ProductKey } from '@flows/index'

export const getProductParamPath = <TName extends string>(productKey: ProductKey, name: TName) =>
  `products.${productKey}.configuration_parameters.${name}` as const
export const getTransientPath = <TName extends string>(name: TName) => `transientValues.${name}`
export const getProductHelperPath = <TName extends string>(productKey: ProductKey, name: TName) =>
  `helperValues.${productKey}.${name}`
export const generateGetFlowValueFunctions = <TName extends string>(
  defaultProductKey: ProductKey
) => ({
  getProductConfigurationParameters: (
    formValues: FlowValues,
    productKey: ProductKey = defaultProductKey
  ) => _get(formValues, `products.${productKey}.configuration_parameters`),
  getParamPath: (name: TName, productKey: ProductKey = defaultProductKey) =>
    getProductParamPath(productKey, name),
  getHelperPath: (name: string, productKey: ProductKey = defaultProductKey) =>
    getProductHelperPath(productKey, name),
  getTransientPath,
})
